export type DestinationCardData = {
  title: string
  viewText: string
  image: string
  path: string
}

export type DestinationRowData = {
  title: string
  subtitle: string
  destinations: DestinationCardData[]
}

const IMG_BASE =
  "https://as.signaturestaycollection.com/travel-agent-portal/figma-destination-images"

export const destinationRows: DestinationRowData[] = [
  {
    title: "Urban & City Locations",
    subtitle: "Where culture, food, and city energy come together",
    destinations: [
      {
        title: "New York state of mind",
        viewText: "View New York stays",
        image: `${IMG_BASE}/row2-urban-city/new-york-187db1.webp`,
        path: "/vacation-rentals/New-York--New-York--USA",
      },
      {
        title: "Vibrant colors of Mexico City",
        viewText: "View Mexico City stays",
        image: `${IMG_BASE}/row2-urban-city/mexico-city-664779.webp`,
        path: "/vacation-rentals/Mexico-City--Mexico",
      },
      {
        title: "Timeless charm of London",
        viewText: "View London stays",
        image: `${IMG_BASE}/row2-urban-city/london-3992b6.webp`,
        path: "/vacation-rentals/London--England--UK",
      },
      {
        title: "Coffee culture in Seattle",
        viewText: "View Seattle stays",
        image: `${IMG_BASE}/row2-urban-city/seattle-350105.webp`,
        path: "/vacation-rentals/Seattle--Washington--USA",
      },
      {
        title: "The Windy City awaits",
        viewText: "View Chicago stays",
        image: `${IMG_BASE}/row2-urban-city/chicago-656d72.webp`,
        path: "/vacation-rentals/Chicago--Illinois--USA",
      },
      {
        title: "Music and soul in Nashville",
        viewText: "View Nashville stays",
        image: `${IMG_BASE}/row2-urban-city/nashville-3cb370.webp`,
        path: "/vacation-rentals/Nashville--Tennessee--USA",
      },
      {
        title: "Sun-soaked Los Angeles",
        viewText: "View Los Angeles stays",
        image: `${IMG_BASE}/row2-urban-city/los-angeles-3517c6.webp`,
        path: "/vacation-rentals/Los-Angeles--California--USA",
      },
    ],
  },
  {
    title: "Nature & Mountains",
    subtitle: "Fresh air, open spaces, and unforgettable landscapes",
    destinations: [
      {
        title: "Smoky Mountain magic in Gatlinburg",
        viewText: "View Gatlinburg stays",
        image: `${IMG_BASE}/row3-nature-mountains/gatlinburg-4e2d8b.webp`,
        path: "/vacation-rentals/Gatlinburg--Tennessee--USA",
      },
      {
        title: "Rustic retreat in Broken Bow",
        viewText: "View Broken Bow stays",
        image: `${IMG_BASE}/row3-nature-mountains/broken-bow-6c99b9.webp`,
        path: "/vacation-rentals/Broken-Bow--Oklahoma--USA",
      },
      {
        title: "Alpine adventure in Whistler",
        viewText: "View Whistler stays",
        image: `${IMG_BASE}/row3-nature-mountains/whistler-744c6b.webp`,
        path: "/vacation-rentals/Whistler--British-Columbia--Canada",
      },
      {
        title: "Red rock wonder in Moab",
        viewText: "View Moab stays",
        image: `${IMG_BASE}/row3-nature-mountains/moab-3c9b01.webp`,
        path: "/vacation-rentals/Moab--Utah--USA",
      },
      {
        title: "Year-round beauty at Lake Tahoe",
        viewText: "View Lake Tahoe stays",
        image: `${IMG_BASE}/row3-nature-mountains/lake-tahoe-b00303.webp`,
        path: "/vacation-rentals/Lake-Tahoe--California--USA",
      },
      {
        title: "Mountain serenity in Banner Elk",
        viewText: "View Banner Elk stays",
        image: `${IMG_BASE}/row3-nature-mountains/banner-elk-384d29.webp`,
        path: "/vacation-rentals/Banner-Elk--North-Carolina--USA",
      },
      {
        title: "Ski and stay in Park City",
        viewText: "View Park City stays",
        image: `${IMG_BASE}/row3-nature-mountains/park-city-378336.webp`,
        path: "/vacation-rentals/Park-City--Utah--USA",
      },
    ],
  },
  {
    title: "California Collection",
    subtitle: "From coastlines to wine country and desert destinations",
    destinations: [
      {
        title: "Mountain escape in Big Bear",
        viewText: "View Big Bear stays",
        image: `${IMG_BASE}/row4-california/big-bear-5cf2c6.webp`,
        path: "/vacation-rentals/Big-Bear--California--USA",
      },
      {
        title: "Desert oasis in Palm Springs",
        viewText: "View Palm Springs stays",
        image: `${IMG_BASE}/row4-california/palm-springs-bac541.webp`,
        path: "/vacation-rentals/Palm-Springs--California--USA",
      },
      {
        title: "Coastal vibes in San Diego",
        viewText: "View San Diego stays",
        image: `${IMG_BASE}/row4-california/san-diego-12e3fe.webp`,
        path: "/vacation-rentals/San-Diego--California--USA",
      },
      {
        title: "Riviera charm in Santa Barbara",
        viewText: "View Santa Barbara stays",
        image: `${IMG_BASE}/row4-california/santa-barbara-4c0248.webp`,
        path: "/vacation-rentals/Santa-Barbara--California--USA",
      },
      {
        title: "Wine country in Napa Valley",
        viewText: "View Napa Valley stays",
        image: `${IMG_BASE}/row4-california/napa-valley-7f9892.webp`,
        path: "/vacation-rentals/Napa-Valley--California--USA",
      },
      {
        title: "Luxury on the coast in Malibu",
        viewText: "View Malibu stays",
        image: `${IMG_BASE}/row4-california/malibu-478df2.webp`,
        path: "/vacation-rentals/Malibu--California--USA",
      },
    ],
  },
  {
    title: "Florida & Disney Stays",
    subtitle: "Theme parks, beaches, and family-ready destinations",
    destinations: [
      {
        title: "Island life in the Florida Keys",
        viewText: "View Florida Keys stays",
        image: `${IMG_BASE}/row5-florida-disney/florida-keys-5b2db1.webp`,
        path: "/vacation-rentals/Florida-Keys--Florida--USA",
      },
      {
        title: "Magic and thrills in Orlando",
        viewText: "View Orlando stays",
        image: `${IMG_BASE}/row5-florida-disney/orlando-3295d0.webp`,
        path: "/vacation-rentals/Orlando--Florida--USA",
      },
      {
        title: "Emerald waters of Destin",
        viewText: "View Destin stays",
        image: `${IMG_BASE}/row5-florida-disney/destin-5b2db1.webp`,
        path: "/vacation-rentals/Destin--Florida--USA",
      },
      {
        title: "Tropical energy of Miami",
        viewText: "View Miami stays",
        image: `${IMG_BASE}/row5-florida-disney/miami-7649bb.webp`,
        path: "/vacation-rentals/Miami--Florida--USA",
      },
      {
        title: "Bay breezes in Tampa",
        viewText: "View Tampa Bay stays",
        image: `${IMG_BASE}/row5-florida-disney/tampa-bay-63b744.webp`,
        path: "/vacation-rentals/Tampa--Florida--USA",
      },
      {
        title: "Scenic shores along 30A",
        viewText: "View 30A stays",
        image: `${IMG_BASE}/row5-florida-disney/30a-6acf69.webp`,
        path: "/vacation-rentals/30A--Florida--USA",
      },
    ],
  },
  {
    title: "European Charms",
    subtitle: "Historic cities, coastal towns, and timeless destinations",
    destinations: [
      {
        title: "Rolling hills of Tuscany",
        viewText: "View Tuscany stays",
        image: `${IMG_BASE}/row6-european-charms/tuscany-190e25.webp`,
        path: "/vacation-rentals/Tuscany--Italy",
      },
      {
        title: "Crystal waters of Croatia",
        viewText: "View Croatia stays",
        image: `${IMG_BASE}/row6-european-charms/croatia-ec6e73.webp`,
        path: "/vacation-rentals/Croatia",
      },
      {
        title: "Alpine beauty of Switzerland",
        viewText: "View Switzerland stays",
        image: `${IMG_BASE}/row6-european-charms/switzerland-c62281.webp`,
        path: "/vacation-rentals/Switzerland",
      },
      {
        title: "Romance and lights in Paris",
        viewText: "View Paris stays",
        image: `${IMG_BASE}/row6-european-charms/paris.webp`,
        path: "/vacation-rentals/Paris--France",
      },
      {
        title: "Timeless charm of London",
        viewText: "View London stays",
        image: `${IMG_BASE}/row6-european-charms/london-eu-11dfbb.webp`,
        path: "/vacation-rentals/London--England--UK",
      },
      {
        title: "Mediterranean sun in Mallorca",
        viewText: "View Mallorca stays",
        image: `${IMG_BASE}/row6-european-charms/mallorca-32343c.webp`,
        path: "/vacation-rentals/Mallorca--Spain",
      },
    ],
  },
  {
    title: "Beach & Coastal Stays",
    subtitle: "Sun, sand, and the most sought-after coastal destinations",
    destinations: [
      {
        title: "Sunny days on the coast of Mexico",
        viewText: "View Mexico stays",
        image: `${IMG_BASE}/row7-beach-coastal/mexico-6f21e8.webp`,
        path: "/vacation-rentals/Mexico",
      },
      {
        title: "Paradise found in Hawaii",
        viewText: "View Hawaii stays",
        image: `${IMG_BASE}/row7-beach-coastal/hawaii-374608.webp`,
        path: "/vacation-rentals/Hawaii--USA",
      },
      {
        title: "Island vibes in the Caribbean",
        viewText: "View Caribbean stays",
        image: `${IMG_BASE}/row7-beach-coastal/caribbean-14a859.webp`,
        path: "/vacation-rentals/Caribbean",
      },
      {
        title: "Warm sands of Gulf Shores",
        viewText: "View Gulf Shores stays",
        image: `${IMG_BASE}/row7-beach-coastal/gulf-shores-47351d.webp`,
        path: "/vacation-rentals/Gulf-Shores--Alabama--USA",
      },
      {
        title: "Breezy days on the Outer Banks",
        viewText: "View Outer Banks stays",
        image: `${IMG_BASE}/row7-beach-coastal/outer-banks-1cdfcc.webp`,
        path: "/vacation-rentals/Outer-Banks--North-Carolina--USA",
      },
      {
        title: "Lowcountry charm of Hilton Head",
        viewText: "View Hilton Head stays",
        image: `${IMG_BASE}/row7-beach-coastal/hilton-head-1be3b2.webp`,
        path: "/vacation-rentals/Hilton-Head--South-Carolina--USA",
      },
    ],
  },
]
